<template>
    <div class="ai">
        <headerassembly />
        <div class="main-container">
            <div class="sidebar">
                <button class="new-chat-btn" @click="createNewChat">
                    新建聊天
                </button>
                <div class="chat-list">
                    <div v-for="(chat, idx) in chats" :key="chat.id"
                        :class="['chat-item', { active: activeChatId === chat.id }]" @click="switchChat(chat.id)">
                        <span>{{ getChatTitle(chat, idx) }}</span>
                        <span class="close-chat" @click.stop="removeChat(chat.id)"
                            v-if="chats.length > 1">&times;</span>
                    </div>
                </div>
            </div>
            <div class="chat-container">
                <div class="chat-messages">
                    <div class="ai-logo-container">
                        <img class="ai-logo" src="../../assets/ai/ai_logo@2x.png" alt="ai_log" />
                    </div>
                    <div class="messages-container">
                        <div v-for="(message, index) in currentMessages" :key="index" class="message-item">
                            <img :src="getAvatar(message.role)" class="avatar" :alt="message.role">
                            <div class="message-content" :class="message.role">
                                <div v-html="formatContent(message)"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="input-area">
                    <div class="ai-text-container">
                        <textarea class="ai-text" v-model="newMessage" placeholder="在这里输入问题"
                            @keyup.enter.exact="debounce('send')" @keyup.ctrl.enter="debounce('send')"></textarea>
                        <img v-if="!processingChats[activeChatId]" class="send-btn" @click="debounce('send')"
                            src="../../assets/ai/ai_send@2x.png" alt="send_message" />
                        <img v-else class="stop-btn" @click="debounce('stop')" src="../../assets/ai/ai_stop.png"
                            alt="stop_generation" />
                    </div>
                    <div class="bottom-tip">
                        <p class="tip-p">内容由AI生成，无法确保真实准确，仅供参考，对于用药、诊疗等医学专业内容，建议直接咨询医生，以免错误用药或延误病情。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import headerassembly from "@/components/headerassembly/headerassembly";
import avatar from '@/assets/default/avatar.png'
import systemlog from '@/assets/app/icon_logo_太极龙@2x.png'
import watermark from "@/util/warterMarkVUE";
import { marked } from 'marked';
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';

import {
    aitalkAPI,
} from "@/util/axiosHttp";

import { hemeraApi } from "@/util/axios";

import axios from 'axios';

export default {
    components: {
        headerassembly,
    },

    metaInfo() {
        return {
            title: '中医智库 - 让中医药为人类健康事业做出更大贡献',
        };
    },
    data() {
        return {
            chats: [],
            activeChatId: null,
            newMessage: '',
            inputMessages: {}, // 存储每个聊天的输入框内容
            systemAvatar: systemlog,
            userAvatar: avatar,
            typingMessage: '',
            waitingDots: '',
            waitingInterval: null,
            isProcessing: false,
            processingChats: {}, // 存储每个聊天的处理状态
            scrollPositions: {}, // 存储每个聊天的滚动位置
            shouldAutoScroll: {}, // 是否应该自动滚动
            currentReader: null,
            currentController: null,
            typingSpeed: 5,
            typingIntervals: {},
            updateFrequency: 2, // 控制UI更新频率
            lastChunkTime: 0, // 记录上次更新的时间
            bufferDelay: 25, // 文字显示的缓冲延迟
            textBuffer: '', // 文字缓冲区
            debounceTimer: null, // 用于防抖
            buttonLock: false, // 按钮锁定状态
        };
    },
    computed: {
        currentChat() {
            return this.chats.find(chat => chat.id === this.activeChatId) || {};
        },
        currentMessages() {
            return this.currentChat.messages || [];
        },
        // 当前聊天的处理状态
        currentChatProcessing() {
            return this.processingChats[this.activeChatId] || false;
        }
    },
    beforeCreate() {
        this.$commFun.loginTypes().then(res => {
            if (res.status_code == "200") {
                this.userAvatar = res.data.avatar
            }
        })
    },

    watch: {
        $route(to, from) {
            window.location.reload(); //监测到路由发生跳转时刷新一次页面
        },
    },
    mounted() {
        if (this.$store.state.indexKey != "") {
            this.classType = this.$store.state.indexKey;
        }
        watermark.set("AI中医智库");

        // 初始化processingChats和scrollPositions为空对象
        this.processingChats = {};
        this.scrollPositions = {};
        this.shouldAutoScroll = {};

        // 从localStorage加载聊天记录
        this.loadChatsFromLocalStorage();

        // 如果没有聊天记录，创建一个新聊天
        if (this.chats.length === 0) {
            this.createNewChat();
        } else {
            // 默认选中最后一个聊天
            this.activeChatId = this.chats[this.chats.length - 1].id;

            // 初始化所有聊天的处理状态和滚动位置
            this.chats.forEach(chat => {
                this.$set(this.processingChats, chat.id, false);
                this.$set(this.scrollPositions, chat.id, 0);
                this.$set(this.shouldAutoScroll, chat.id, true);
            });

            // 确保滚动到正确位置
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        }

        // 添加滚动事件监听
        this.$nextTick(() => {
            const chatContainer = this.$el.querySelector('.chat-messages');
            if (chatContainer) {
                chatContainer.addEventListener('scroll', this.handleScroll);
            }
        });

    },

    beforeRouteLeave(to, from, next) {
        let id = '1.23452384164.123412415'
        if (document.getElementById(id) !== null) {
            document.body.removeChild(document.getElementById(id))
        }

        // 清除所有计时器
        if (this.waitingInterval) {
            clearInterval(this.waitingInterval);
        }

        next(); // 必须调用该方法来resolve这个钩子
    },
    beforeDestroy() {
        // 移除滚动事件监听
        const chatContainer = this.$el.querySelector('.chat-messages');
        if (chatContainer) {
            chatContainer.removeEventListener('scroll', this.handleScroll);
        }
    },
    methods: {
        // 创建新的聊天
        createNewChat() {
            const newChatId = Date.now().toString();
            const newChat = {
                id: newChatId,
                messages: [{ "role": "system", "content": "您好！我是AI中医智库，期待为您提供专业的中医知识服务！", "typing": false }]
            };

            // 保存当前聊天的状态
            if (this.activeChatId) {
                this.inputMessages[this.activeChatId] = this.newMessage;
                // 保存当前聊天的滚动位置
                const chatContainer = this.$el.querySelector('.chat-messages');
                if (chatContainer) {
                    this.$set(this.scrollPositions, this.activeChatId, chatContainer.scrollTop);
                }
            }

            this.chats.push(newChat);
            this.activeChatId = newChatId;
            this.newMessage = ''; // 清空输入框
            this.inputMessages[newChatId] = ''; // 初始化新聊天的输入框内容
            this.$set(this.processingChats, newChatId, false); // 使用$set初始化新聊天的处理状态
            this.$set(this.scrollPositions, newChatId, 0); // 新聊天的滚动位置初始为0
            this.$set(this.shouldAutoScroll, newChatId, true); // 新聊天应该自动滚动

            this.saveChatsToLocalStorage();

            // 滚动到顶部
            this.$nextTick(() => {
                const chatContainer = this.$el.querySelector('.chat-messages');
                if (chatContainer) {
                    chatContainer.scrollTop = 0;
                }
            });
        },

        // 切换到指定聊天
        switchChat(chatId) {
            // 保存当前聊天的滚动位置
            if (this.activeChatId) {
                // 保存当前聊天的输入框内容
                this.inputMessages[this.activeChatId] = this.newMessage;

                // 保存当前聊天的滚动位置
                const chatContainer = this.$el.querySelector('.chat-messages');
                if (chatContainer) {
                    this.$set(this.scrollPositions, this.activeChatId, chatContainer.scrollTop);
                }

                // 关键修改：暂停先前聊天的自动滚动，即使它正在处理消息
                this.$set(this.shouldAutoScroll, this.activeChatId, false);
            }

            // 切换到新聊天
            this.activeChatId = chatId;

            // 为新的当前聊天启用自动滚动，只有当前活跃的聊天才会滚动
            this.$set(this.shouldAutoScroll, chatId, true);

            // 恢复新聊天的输入框内容
            this.newMessage = this.inputMessages[chatId] || '';

            // 在下一个渲染周期恢复滚动位置
            this.$nextTick(() => {
                const chatContainer = this.$el.querySelector('.chat-messages');
                if (chatContainer) {
                    // 恢复保存的滚动位置或滚动到底部
                    if (this.scrollPositions[chatId] !== undefined) {
                        chatContainer.scrollTop = this.scrollPositions[chatId];
                    } else {
                        chatContainer.scrollTop = chatContainer.scrollHeight;
                    }
                }
            });
        },

        // 删除指定聊天
        removeChat(chatId) {
            const index = this.chats.findIndex(chat => chat.id === chatId);
            if (index !== -1) {
                this.chats.splice(index, 1);

                // 清理该聊天的相关数据
                delete this.inputMessages[chatId];
                delete this.processingChats[chatId];
                delete this.scrollPositions[chatId];

                // 如果删除的是当前活动聊天，则切换到其他聊天
                if (chatId === this.activeChatId) {
                    this.activeChatId = this.chats.length > 0 ? this.chats[this.chats.length - 1].id : null;

                    // 如果没有聊天了，创建一个新聊天
                    if (this.activeChatId === null) {
                        this.createNewChat();
                    } else {
                        // 恢复选中聊天的滚动位置
                        this.$nextTick(() => {
                            const chatContainer = this.$el.querySelector('.chat-messages');
                            if (chatContainer && this.scrollPositions[this.activeChatId] !== undefined) {
                                chatContainer.scrollTop = this.scrollPositions[this.activeChatId];
                            }
                        });
                    }
                }

                this.saveChatsToLocalStorage();
            }
        },

        // 清除当前聊天的所有消息
        clearCurrentChat() {
            if (confirm('确定要清除当前对话吗？')) {
                const chat = this.chats.find(chat => chat.id === this.activeChatId);
                if (chat) {
                    chat.messages = [{ "role": "system", "content": "您好！我是AI中医智库，期待为您提供专业的中医知识服务！", "typing": false }];
                    this.saveChatsToLocalStorage();
                }
            }
        },

        // 保存聊天记录到localStorage
        saveChatsToLocalStorage() {
            localStorage.setItem('ai_chats', JSON.stringify(this.chats));
        },

        // 从localStorage加载聊天记录
        loadChatsFromLocalStorage() {
            const savedChats = localStorage.getItem('ai_chats');
            if (savedChats) {
                this.chats = JSON.parse(savedChats);
            }
        },

        // 清理和格式化HTML内容
        cleanHtmlContent(htmlContent) {
            // 处理和清除所有可能导致多余空白的HTML元素
            htmlContent = htmlContent.replace(/<p><br><\/p>/g, '');
            htmlContent = htmlContent.replace(/<p>\s*<\/p>/g, '');
            htmlContent = htmlContent.replace(/<p><\/p>/g, '');
            htmlContent = htmlContent.replace(/<p>&nbsp;<\/p>/g, '');
            htmlContent = htmlContent.replace(/<br\s*\/?>\s*$/g, '');

            // 替换可能导致空行的HTML结构
            htmlContent = htmlContent.replace(/<\/p>\s*<p>/g, ' ');

            // 处理连续的换行标签
            htmlContent = htmlContent.replace(/<br\s*\/?>\s*<br\s*\/?>/g, '<br>');
            htmlContent = htmlContent.replace(/<br\s*\/?>\s*<br\s*\/?>/g, '<br>'); // 再次执行以捕获三个以上的连续br

            // 替换p标签为span以避免垂直空间
            htmlContent = htmlContent.replace(/<p>/g, '<span>');
            htmlContent = htmlContent.replace(/<\/p>/g, '</span>');

            return htmlContent.trim();
        },

        // 格式化消息内容，处理等待动画和Markdown
        formatContent(message) {
            // 处理等待动画
            if (message.waiting) {
                return `思考中<span class="typing-dots">${message.content}</span>`;
            }

            // 处理空内容但处于typing状态的情况（显示光标）
            if (message.typing && (!message.content || message.content.trim() === '')) {
                return '<span class="typing-cursor">|</span>';
            }

            // 处理有内容的情况但仍在typing状态
            if (message.typing && message.content) {
                let processed = this.processMessageContent(message.content);
                // 只有在实际内容为空时才显示光标
                if (!processed || processed.trim() === '') {
                    return '<span class="typing-cursor">|</span>';
                }
                return processed;
            }

            // 处理有内容的情况
            if (message.content) {
                return this.processMessageContent(message.content);
            }

            // 处理既没有内容也没有typing状态的情况
            return '';
        },

        // 处理消息内容
        processMessageContent(content) {
            // 先过滤掉所有<think相关标签和特殊标记
            let filteredContent = content.replace(/<think|think>|<\|im_sep\|>|\|im_sep\||<im_sep|im_sep/g, '');

            // 去除消息内容末尾的换行符
            while (filteredContent.endsWith('\n')) {
                filteredContent = filteredContent.slice(0, -1);
            }

            // 将连续的多个换行符替换为单个换行符
            filteredContent = filteredContent.replace(/\n{2,}/g, '\n');

            // 处理思考过程的特殊样式
            if (filteredContent.includes('<span class="thinking">') || filteredContent.includes('<span class="thinking-complete">')) {
                // 如果包含思考标签，保留HTML结构但处理Markdown
                let thinkingPart = '';
                let contentPart = '';

                if (filteredContent.includes('<span class="thinking">')) {
                    const parts = filteredContent.split('</span>');
                    thinkingPart = parts[0] + '</span>';
                    contentPart = parts.slice(1).join('</span>');
                } else if (filteredContent.includes('<span class="thinking-complete">')) {
                    const parts = filteredContent.split('</span>');
                    thinkingPart = parts[0] + '</span>';
                    contentPart = parts.slice(1).join('</span>');
                }

                // 只对正文部分应用Markdown
                marked.setOptions({
                    highlight: function (code, lang) {
                        if (lang && hljs.getLanguage(lang)) {
                            try {
                                return hljs.highlight(code, { language: lang }).value;
                            } catch (__) { }
                        }
                        return code;
                    },
                    breaks: true,
                    gfm: true
                });

                let htmlContent = contentPart ? marked(contentPart) : '';
                htmlContent = this.cleanHtmlContent(htmlContent);

                // 返回处理后的内容
                return thinkingPart + htmlContent;
            }

            marked.setOptions({
                highlight: function (code, lang) {
                    if (lang && hljs.getLanguage(lang)) {
                        try {
                            return hljs.highlight(code, { language: lang }).value;
                        } catch (__) { }
                    }
                    return code;
                },
                breaks: true,
                gfm: true
            });

            // 处理Markdown内容
            let htmlContent = marked(filteredContent);
            htmlContent = this.cleanHtmlContent(htmlContent);

            // 返回处理后的内容
            return htmlContent;
        },

        // 按钮防抖处理
        debounce(action) {
            if (this.buttonLock) return; // 如果按钮已锁定，直接返回

            this.buttonLock = true; // 锁定按钮

            // 根据action执行对应的操作
            if (action === 'send') {
                this.sendMessage();
            } else if (action === 'stop') {
                this.stopGeneration();
            }

            // 300ms后解锁按钮
            setTimeout(() => {
                this.buttonLock = false;
            }, 300);
        },

        // 发送消息
        sendMessage() {
            if (this.newMessage.trim() === '' || this.processingChats[this.activeChatId]) {
                return;
            }

            const chat = this.chats.find(chat => chat.id === this.activeChatId);
            if (!chat) return;

            // 立即设置处理状态，确保按钮状态立即变化
            this.$set(this.processingChats, this.activeChatId, true);
            this.isProcessing = true;

            // 发送新消息时，只重置当前激活聊天的自动滚动标志
            this.$set(this.shouldAutoScroll, this.activeChatId, true);


            // 强制更新视图，确保按钮状态立即变化
            this.$forceUpdate();

            // 获取当前聊天的历史消息，用于实现多轮对话
            chat.messages.push({ role: "user", content: this.newMessage, typing: false });
            this.scrollToBottom();

            // 添加等待消息
            const waitingIndex = chat.messages.push({
                role: 'system',
                content: '...',
                waiting: true
            }) - 1;

            // 启动等待动画
            this.startWaitingAnimation(waitingIndex);

            // 清空输入框
            this.newMessage = '';
            this.inputMessages[this.activeChatId] = '';

            // 构建多轮对话的上下文
            const conversationHistory = chat.messages
                .filter(msg => {
                    // 过滤掉等待消息、打字消息、默认的系统欢迎消息和错误消息
                    return !msg.waiting &&
                        !msg.typing &&
                        !msg.incomplete &&
                        msg.content !== "您好！我是AI中医智库，期待为您提供专业的中医知识服务！" &&
                        msg.content !== "服务器繁忙，请稍后再试。" &&
                        !msg.content.includes("发生错误") &&
                        !msg.content.includes("请求超时") &&
                        !msg.content.includes("没有接收到有效的回复内容") &&
                        !msg.content.includes("读取数据流时出错") &&
                        !msg.content.includes("发送请求时出错") &&
                        !msg.content.includes("生成已停止");
                })
                .map(msg => ({
                    role: msg.role === 'system' ? 'assistant' : msg.role,
                    content: msg.content
                }));

            // 准备API请求参数
            const requestData = {
                messages: JSON.stringify(conversationHistory),
                user_id: 1  // 用户ID，应该从用户信息中获取
            };

            // 更新消息状态为正常显示
            chat.messages[waitingIndex] = {
                role: "system",
                content: "",
                typing: false
            };

            // 停止等待动画
            this.stopWaitingAnimation();

            // 触发界面更新
            this.chats = [...this.chats];

            let isThinking = false;
            let thinkingContent = "";
            let responseContent = "";
            let partialTag = "";

            // 获取token
            const accToken = localStorage.getItem('login') &&
                localStorage.getItem('login') != "undefined" &&
                JSON.parse(localStorage.getItem('login')).access_token ?
                JSON.parse(localStorage.getItem('login')).access_token : "";

            // Get the API URL from hemeraApi
            let apiURLHemera = hemeraApi.defaults.baseURL;

            // 设置初始加载状态，添加闪烁光标
            chat.messages[waitingIndex] = {
                role: "system",
                content: '',
                typing: true
            };
            // 触发界面更新
            this.chats = [...this.chats];
            if (this.activeChatId === chat.id) {
                this.scrollToBottom();
            }

            // 使用fetch API处理流式响应
            try {

                // 创建 AbortController 用于中止请求
                this.currentController = new AbortController();
                const signal = this.currentController.signal;

                // 设置请求参数
                const fetchOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': accToken,
                        'Cache-Control': 'no-cache',
                        'Accept': 'text/event-stream'
                    },
                    body: JSON.stringify(requestData),
                    // 重要: 这些设置对于流式响应至关重要
                    cache: 'no-store',
                    credentials: 'same-origin',
                    keepalive: true, // 保持连接
                    signal, // 添加 signal 用于中止请求
                };

                // 使用fetch API

                // 开始fetch请求，添加详细的错误处理和调试信息
                fetch(`${apiURLHemera}ai_stream`, fetchOptions)
                    .then(response => {

                        if (!response.ok) {
                            throw new Error(`Server responded with status: ${response.status}`);
                        }

                        if (!response.body) {
                            throw new Error('Response body is null or undefined');
                        }

                        // 创建一个新的EventSource格式的reader
                        this.currentReader = response.body.getReader();
                        const decoder = new TextDecoder('utf-8');
                        let buffer = ''; // 用于存储未完成的事件数据

                        // 处理数据流
                        const processStream = () => {
                            // 读取数据块
                            return this.currentReader.read().then(({ done, value }) => {
                                // 如果数据流结束，则返回
                                if (done) {
                                    // 如果结束时没有有效内容，显示错误信息
                                    if (responseContent === '') {
                                        chat.messages[waitingIndex] = {
                                            role: "system",
                                            content: "没有接收到有效的回复内容",
                                            typing: false
                                        };
                                        this.chats = [...this.chats];
                                    } else {
                                        // 确保最终状态正确
                                        // 去除消息内容末尾的换行符
                                        while (responseContent.endsWith('\n')) {
                                            responseContent = responseContent.slice(0, -1);
                                        }

                                        // 修改：在完成时也保留思考内容，但仅当思考内容有实质内容时
                                        if (thinkingContent && thinkingContent.trim() !== '') {
                                            chat.messages[waitingIndex] = {
                                                role: "system",
                                                content: `<span class="thinking-complete">思考过程：${thinkingContent}</span>${responseContent}`,
                                                typing: false // 生成完成时关闭typing
                                            };
                                        } else {
                                            chat.messages[waitingIndex] = {
                                                role: "system",
                                                content: responseContent,
                                                typing: false // 生成完成时关闭typing
                                            };
                                        }

                                        this.chats = [...this.chats];
                                        this.saveChatsToLocalStorage();

                                        // 确保重置处理状态
                                        this.isProcessing = false;
                                        this.$set(this.processingChats, this.activeChatId, false);

                                        // 强制更新视图，确保按钮状态立即变化
                                        this.$forceUpdate();

                                        this.currentReader = null;
                                        this.currentController = null;
                                        return;
                                    }
                                }

                                try {
                                    // 解码接收到的数据
                                    const chunk = decoder.decode(value, { stream: true });

                                    // 添加到缓冲区
                                    buffer += chunk;

                                    // 识别并处理完整的SSE事件
                                    let processedBuffer = '';
                                    // 寻找双换行符，这是SSE事件的分隔符
                                    while (buffer.includes('\n\n')) {
                                        const eventEnd = buffer.indexOf('\n\n') + 2;
                                        const eventText = buffer.substring(0, eventEnd);
                                        buffer = buffer.substring(eventEnd);

                                        // 处理事件
                                        const lines = eventText.split('\n');
                                        let eventType = 'message';
                                        let eventData = '';

                                        lines.forEach(line => {
                                            if (line.startsWith('event:')) {
                                                eventType = line.substring(6).trim();
                                            } else if (line.startsWith('data:')) {
                                                eventData = line.substring(5).trim();
                                            }
                                        });

                                        processedBuffer += eventText;

                                        // 根据事件类型处理
                                        if (eventType === 'connected') {
                                            console.log('Connected to SSE stream');
                                        } else if (eventData === '[DONE]') {
                                            console.log('Stream finished with [DONE] signal');
                                            // 去除消息内容末尾的换行符
                                            while (responseContent.endsWith('\n')) {
                                                responseContent = responseContent.slice(0, -1);
                                            }
                                            chat.messages[waitingIndex] = {
                                                role: "system",
                                                content: responseContent,
                                                typing: false
                                            };
                                            this.chats = [...this.chats];
                                            this.saveChatsToLocalStorage();
                                            this.isProcessing = false; // 重置处理状态
                                            this.$set(this.processingChats, this.activeChatId, false);
                                        } else if (eventData) {
                                            try {
                                                const data = JSON.parse(eventData);

                                                if (data.status_code === 200 && data.data) {
                                                    const chunkText = data.data.chunk || '';
                                                    const isFinal = data.data.is_final || false;

                                                    // 添加到缓冲区
                                                    this.textBuffer += chunkText;

                                                    // 检查是否应该更新UI
                                                    const currentTime = Date.now();
                                                    if (currentTime - this.lastChunkTime >= this.bufferDelay || isFinal) {
                                                        // 是时候更新UI了
                                                        this.lastChunkTime = currentTime;

                                                        // 处理缓冲区中的文本
                                                        if (this.textBuffer) {
                                                            // 处理<think>标签
                                                            partialTag += this.textBuffer;
                                                            this.textBuffer = ''; // 清空缓冲区

                                                            // 检测思考模式标签
                                                            if (partialTag.includes("<think>") && !isThinking) {
                                                                isThinking = true;
                                                                const thinkStartIdx = partialTag.indexOf("<think>");
                                                                responseContent += partialTag.substring(0, thinkStartIdx);
                                                                partialTag = partialTag.substring(thinkStartIdx + 7); // 7 是 <think> 的长度
                                                                // 确保思考内容不包含任何HTML标签或特殊标记
                                                                thinkingContent = partialTag.replace(/<think|think>|<\|im_sep\|>|\|im_sep\||<im_sep|im_sep/g, '');
                                                            }
                                                            else if (partialTag.includes("</think>") && isThinking) {
                                                                isThinking = false;
                                                                const thinkEndIdx = partialTag.indexOf("</think>");
                                                                // 确保思考内容不包含任何HTML标签或特殊标记
                                                                thinkingContent = partialTag.substring(0, thinkEndIdx).replace(/<think|think>|<\|im_sep\|>|\|im_sep\||<im_sep|im_sep/g, '');
                                                                partialTag = partialTag.substring(thinkEndIdx + 8); // 8 是 </think> 的长度
                                                                responseContent += partialTag;
                                                            }
                                                            else if (isThinking) {
                                                                // 确保思考内容不包含任何HTML标签或特殊标记
                                                                thinkingContent = partialTag.replace(/<think|think>|<\|im_sep\|>|\|im_sep\||<im_sep|im_sep/g, '');
                                                            }
                                                            else {
                                                                // 过滤掉普通内容中可能的特殊标记
                                                                responseContent = partialTag.replace(/<think|think>|<\|im_sep\|>|\|im_sep\||<im_sep|im_sep/g, '');
                                                            }

                                                            // 在显示时清除末尾换行符，但保留原始内容用于继续拼接
                                                            let displayContent = responseContent;
                                                            while (displayContent.endsWith('\n')) {
                                                                displayContent = displayContent.slice(0, -1);
                                                            }

                                                            // 更新UI
                                                            if (isThinking) {
                                                                // 检查思考内容是否有实质内容（不仅仅是空格、换行符等）
                                                                if (thinkingContent && thinkingContent.trim() !== '') {
                                                                    let newContent = `<span class="thinking">思考中：${thinkingContent}</span>${displayContent}`;
                                                                    chat.messages[waitingIndex] = {
                                                                        role: "system",
                                                                        content: newContent,
                                                                        typing: true
                                                                    };
                                                                } else {
                                                                    // 没有实质内容时，只显示正常内容
                                                                    chat.messages[waitingIndex] = {
                                                                        role: "system",
                                                                        content: displayContent,
                                                                        typing: true
                                                                    };
                                                                }
                                                            } else {
                                                                let newContent;
                                                                // 检查思考内容是否有实质内容（不仅仅是空格、换行符等）
                                                                if (thinkingContent && thinkingContent.trim() !== '') {
                                                                    newContent = `<span class="thinking-complete">思考过程：${thinkingContent.replace(/<[^>]*>/g, '')}</span>${displayContent}`;
                                                                } else {
                                                                    newContent = displayContent;
                                                                }

                                                                chat.messages[waitingIndex] = {
                                                                    role: "system",
                                                                    content: newContent,
                                                                    typing: true // 保持typing状态，但光标会根据内容是否为空决定是否显示
                                                                };
                                                            }

                                                            // 更新UI
                                                            this.chats = [...this.chats];

                                                            // 更新后只有当前激活的聊天才滚动
                                                            this.$forceUpdate();
                                                            if (this.activeChatId === chat.id) {
                                                                this.scrollToBottom();
                                                            }
                                                        }
                                                    }

                                                    if (isFinal) {
                                                        // 完成响应
                                                        // 去除消息内容末尾的换行符
                                                        while (responseContent.endsWith('\n')) {
                                                            responseContent = responseContent.slice(0, -1);
                                                        }

                                                        // 修改：在完成时也保留思考内容，但仅当思考内容有实质内容时
                                                        if (thinkingContent && thinkingContent.trim() !== '') {
                                                            chat.messages[waitingIndex] = {
                                                                role: "system",
                                                                content: `<span class="thinking-complete">思考过程：${thinkingContent}</span>${responseContent}`,
                                                                typing: false // 生成完成时关闭typing
                                                            };
                                                        } else {
                                                            chat.messages[waitingIndex] = {
                                                                role: "system",
                                                                content: responseContent,
                                                                typing: false // 生成完成时关闭typing
                                                            };
                                                        }

                                                        this.chats = [...this.chats];
                                                        this.saveChatsToLocalStorage();

                                                        // 确保重置处理状态
                                                        this.isProcessing = false;
                                                        this.$set(this.processingChats, this.activeChatId, false);

                                                        // 强制更新视图，确保按钮状态立即变化
                                                        this.$forceUpdate();

                                                        this.currentReader = null;
                                                        this.currentController = null;
                                                        return;
                                                    }
                                                } else if (data.status_code !== 200) {
                                                    // 处理错误
                                                    console.error('Error in stream:', data);
                                                    chat.messages[waitingIndex] = {
                                                        role: "system",
                                                        content: data.msg || "服务器繁忙，请稍后再试。",
                                                        typing: false
                                                    };
                                                    this.chats = [...this.chats];
                                                    this.saveChatsToLocalStorage();

                                                    // 确保重置处理状态
                                                    this.isProcessing = false;
                                                    this.$set(this.processingChats, this.activeChatId, false);

                                                    // 强制更新视图，确保按钮状态立即变化
                                                    this.$forceUpdate();
                                                }
                                            } catch (e) {
                                                console.error('Error parsing SSE data:', e, 'Original data:', eventData);
                                            }
                                        }
                                    }
                                } catch (e) {
                                    console.error('Error processing chunk:', e);
                                }

                                // 继续处理流
                                return processStream();
                            }).catch(error => {
                                // 检查是否是因为中止请求导致的错误
                                if (error.name === 'AbortError') {
                                    console.log('Stream reading aborted by user');
                                } else {
                                    console.error('Error reading stream:', error);
                                    chat.messages[waitingIndex] = {
                                        role: "system",
                                        content: "服务器繁忙，请稍后再试。",
                                        typing: false  // 确保光标不显示
                                    };
                                    this.chats = [...this.chats];
                                    this.saveChatsToLocalStorage();
                                }

                                // 确保重置处理状态
                                this.isProcessing = false;
                                this.$set(this.processingChats, this.activeChatId, false);

                                // 强制更新视图，确保按钮状态立即变化
                                this.$forceUpdate();

                                this.currentReader = null;
                                this.currentController = null;
                            });
                        };

                        // 开始处理流
                        return processStream();
                    })
                    .catch(error => {
                        // 检查是否是因为中止请求导致的错误
                        if (error.name === 'AbortError') {
                            console.log('Request aborted by user');
                            // 处理中止时的内容，确保没有尾部换行符
                            while (responseContent && responseContent.endsWith('\n')) {
                                responseContent = responseContent.slice(0, -1);
                            }

                            // 如果没有内容，不需要显示消息
                            if (!responseContent || responseContent.trim() === '') {
                                // 移除这条消息
                                chat.messages.pop();
                            } else {
                                // 保存不完整的消息
                                chat.messages[waitingIndex] = {
                                    role: "system",
                                    content: responseContent,
                                    typing: false,
                                    incomplete: true // 标记为不完整消息
                                };
                            }
                        } else {
                            console.error("Fetch error:", error);
                            // 检查是否是Chrome 78的兼容性问题
                            if (error.message && (
                                error.message.includes('ReadableStream') ||
                                error.message.includes('body') ||
                                error.message.includes('getReader')
                            )) {
                                console.log("可能是浏览器兼容性问题，尝试使用完整响应");
                                // 使用完整响应模式作为后备方案
                                this.fallbackToAxios(chat, waitingIndex, requestData, accToken);
                                return;
                            }

                            chat.messages[waitingIndex] = {
                                role: "system",
                                content: "服务器繁忙，请稍后再试。",
                                typing: false
                            };
                        }
                        this.chats = [...this.chats];
                        this.saveChatsToLocalStorage();
                        this.isProcessing = false; // 重置处理状态
                        this.$set(this.processingChats, this.activeChatId, false);
                        this.currentReader = null;
                        this.currentController = null;
                    });

            } catch (error) {
                console.error('Error in sendMessage:', error);
                chat.messages[waitingIndex] = {
                    role: "system",
                    content: "服务器繁忙，请稍后再试。",
                    typing: false
                };
                this.chats = [...this.chats];
                this.saveChatsToLocalStorage();

                // 确保重置处理状态
                this.isProcessing = false;
                this.$set(this.processingChats, this.activeChatId, false);

                // 强制更新视图，确保按钮状态立即变化
                this.$forceUpdate();

                this.currentReader = null;
                this.currentController = null;
            }
        },

        // 启动等待动画
        startWaitingAnimation(index) {
            const chat = this.chats.find(chat => chat.id === this.activeChatId);
            if (!chat) return;

            // 清除之前的计时器
            if (this.waitingInterval) {
                clearInterval(this.waitingInterval);
            }

            let dotCount = 0;

            this.waitingInterval = setInterval(() => {
                dotCount = (dotCount % 3) + 1;
                const dots = '.'.repeat(dotCount);

                // 更新等待消息
                if (chat.messages[index]) {
                    chat.messages[index].content = dots;
                    // 触发界面更新
                    this.chats = [...this.chats];
                }
            }, 500);
        },

        // 停止等待动画
        stopWaitingAnimation() {
            if (this.waitingInterval) {
                clearInterval(this.waitingInterval);
                this.waitingInterval = null;
            }
        },

        getAvatar(role) {
            return role === 'user' ? this.userAvatar : this.systemAvatar;
        },

        scrollToBottom() {
            // 如果没有活动聊天，则跳过
            if (!this.activeChatId) {
                return;
            }

            // 判断是否应该滚动
            // 如果用户已禁用自动滚动，则不滚动
            if (this.shouldAutoScroll[this.activeChatId] === false) {
                return;
            }

            this.$nextTick(() => {
                const chatContainer = this.$el.querySelector('.chat-messages');
                if (chatContainer) {
                    chatContainer.scrollTop = chatContainer.scrollHeight;
                    // 二次确认滚动到底部 (解决某些浏览器延迟加载的问题)
                    setTimeout(() => {
                        chatContainer.scrollTop = chatContainer.scrollHeight;
                    }, 50);

                    // 三次确认滚动到底部 (确保在所有内容完全渲染后滚动)
                    setTimeout(() => {
                        chatContainer.scrollTop = chatContainer.scrollHeight;
                    }, 150);
                }
            });
        },

        getChatTitle(chat, idx) {
            // Find the first user message in the chat
            const firstUserMessage = chat.messages.find(msg => msg.role === 'user');
            if (firstUserMessage) {
                // Return first 10 characters of the message or the full message if shorter
                return firstUserMessage.content.length > 10
                    ? firstUserMessage.content.substring(0, 10) + '...'
                    : firstUserMessage.content;
            }
            // If no user message found, return default title
            return `对话 ${idx + 1}`;
        },

        // 停止生成
        stopGeneration() {
            if (this.currentController) {
                this.currentController.abort();

                // 立即设置处理状态为false，确保按钮状态立即变化
                this.$set(this.processingChats, this.activeChatId, false);
                this.isProcessing = false;


                // 强制更新视图，确保按钮状态立即变化
                this.$forceUpdate();

                // 获取当前聊天
                const chat = this.chats.find(chat => chat.id === this.activeChatId);
                if (chat && chat.messages.length > 0) {
                    const lastMessage = chat.messages[chat.messages.length - 1];

                    // 如果消息是空的，直接移除这条消息
                    if (lastMessage.role === 'system' && (!lastMessage.content || lastMessage.content.trim() === '')) {
                        chat.messages.pop();
                    }
                    // 否则标记为已完成状态
                    else if (lastMessage.role === 'system' && lastMessage.typing) {
                        lastMessage.typing = false;
                        lastMessage.incomplete = true; // 标记为不完整消息
                    }

                    this.chats = [...this.chats]; // 触发视图更新
                    this.saveChatsToLocalStorage(); // 保存到本地存储
                }

                this.currentReader = null;
                this.currentController = null;
            }
        },

        // 添加新方法：实现打字机效果
        simulateTyping(index, text, delay) {
            // 清除之前的计时器
            if (this.typingIntervals[index]) {
                clearInterval(this.typingIntervals[index]);
            }

            const chat = this.chats.find(chat => chat.id === this.activeChatId);
            if (!chat || !chat.messages[index]) return;

            // 确保光标可见
            chat.messages[index].typing = true;

            // 强制触发界面更新
            this.chats = [...this.chats];
            this.scrollToBottom();

            // 根据文本长度计算显示时间，但大幅缩短显示时间
            const typingTime = Math.max(500, text.length * delay / 10);

            // 完成打字效果后隐藏光标
            setTimeout(() => {
                if (chat.messages[index]) {
                    chat.messages[index].typing = false;
                    // 触发界面更新
                    this.chats = [...this.chats];
                    this.scrollToBottom();
                }
            }, typingTime);
        },

        // 处理滚动事件，实时保存当前聊天的滚动位置
        handleScroll() {
            if (!this.activeChatId) return;

            const chatContainer = this.$el.querySelector('.chat-messages');
            if (chatContainer) {
                // 保存当前滚动位置
                this.$set(this.scrollPositions, this.activeChatId, chatContainer.scrollTop);

                // 判断是否在底部附近
                const isNearBottom = chatContainer.scrollHeight - chatContainer.scrollTop - chatContainer.clientHeight < 100;

                // 只对当前激活的聊天页设置自动滚动
                if (!isNearBottom && this.processingChats[this.activeChatId]) {
                    this.$set(this.shouldAutoScroll, this.activeChatId, false);
                }

                // 如果用户滚动到底部附近，只重新启用当前激活聊天的自动滚动
                if (isNearBottom && this.processingChats[this.activeChatId]) {
                    this.$set(this.shouldAutoScroll, this.activeChatId, true);
                }
            }
        },

        // 添加新的方法：处理Chrome 78的兼容性问题
        fallbackToAxios(chat, waitingIndex, requestData, accToken) {
            // 显示正在尝试备用方式
            chat.messages[waitingIndex] = {
                role: "system",
                content: "尝试备用连接方式...",
                typing: true
            };
            this.chats = [...this.chats];

            // 使用完整响应模式作为后备方案
            aitalkAPI(requestData)
                .then(response => {
                    if (response.data.status_code === 200) {
                        chat.messages[waitingIndex] = {
                            role: "system",
                            content: response.data.data.content || "获取到回复，但内容为空",
                            typing: false
                        };
                    } else {
                        chat.messages[waitingIndex] = {
                            role: "system",
                            content: response.data.msg || "服务器返回错误",
                            typing: false
                        };
                    }
                })
                .catch(error => {
                    console.error('Fallback request failed:', error);
                    chat.messages[waitingIndex] = {
                        role: "system",
                        content: "连接服务器失败，请稍后再试",
                        typing: false
                    };
                })
                .finally(() => {
                    this.chats = [...this.chats];
                    this.saveChatsToLocalStorage();
                    this.isProcessing = false;
                    this.$set(this.processingChats, this.activeChatId, false);
                    this.$forceUpdate();
                    this.currentReader = null;
                    this.currentController = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.ai {
    width: 100%;
    height: 100%;
    background: #f6f4f1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.main-container {
    display: flex;
    height: calc(100% - 60px); // Adjust based on your header height
}

.sidebar {
    width: 270px;
    background-color: #ffffff;
    padding: 20px;
    border-right: 1px solid #E8E5E0;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.new-chat-btn {
    width: 100%;
    padding: 12px;
    background-color: #E8E5E0;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    font-family: PingFang-SC-Medium;
    color: #333333;
    font-weight: 500;
    transition: background-color 0.2s;

    &:hover {
        background-color: #D4CFC8;
    }
}

.chat-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: auto;
}

.chat-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    background-color: #F6F4F1;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #E8E5E0;
    }

    &.active {
        background-color: #D4CFC8;
        font-weight: bold;
    }
}

.close-chat {
    font-size: 18px;
    line-height: 1;
    padding: 4px;
    border-radius: 4px;

    &:hover {
        background-color: rgba(0, 0, 0, 0.1);
    }
}

.chat-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    padding: 0 40px;
}

.chat-messages {
    flex: 1;
    overflow-y: auto;
    padding-right: 0;
    scrollbar-width: thin;
    scrollbar-color: #D4CFC8 transparent;
}

.chat-messages::-webkit-scrollbar {
    width: 8px;
}

.chat-messages::-webkit-scrollbar-track {
    background: transparent;
}

.chat-messages::-webkit-scrollbar-thumb {
    background-color: #D4CFC8;
    border-radius: 4px;
}

.messages-container {
    width: calc(100% - 114px);
    margin-left: 30px;
    margin-right: 30px;
    padding: 15px;
    padding-top: 30px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    word-wrap: break-word;
    white-space: pre-wrap;
    display: block;
    scrollbar-width: thin;
    scrollbar-color: #D4CFC8 transparent;
}

.messages-container::-webkit-scrollbar {
    width: 8px;
}

.messages-container::-webkit-scrollbar-track {
    background: transparent;
}

.messages-container::-webkit-scrollbar-thumb {
    background-color: #D4CFC8;
    border-radius: 4px;
}

.message-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    margin-top: 20px;
    position: relative;
}

.avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
    align-self: flex-start;
}

.message-content {
    width: 100%;
    padding: 15px 20px;
    border-radius: 10px;
    white-space: pre-wrap;
    position: relative;
    min-height: 28px;
    line-height: 1.5;
}

.message-content.user,
.message-content.system {
    display: block;
    text-align: left;
}

/* 对于Markdown内容调整，确保p标签不产生多余边距 */
.message-content :deep(p) {
    margin: 0;
    padding: 0;
    line-height: 1.5;
    display: inline;
}

.message-content :deep(*) {
    margin: 0;
    padding: 0;
}

/* 光标样式 */
.typing-cursor {
    display: inline-block;
    color: #000;
    font-weight: bold;
    font-size: 24px;
    animation: blink 0.8s step-start infinite;
    vertical-align: middle;
    margin-left: 2px;
}

@keyframes blink {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }
}

/* 清除所有其他可能的光标样式 */
.content-with-cursor,
.cursor,
.fixed-cursor,
.message-cursor,
.message-with-cursor,
.blinking-cursor,
.simple-cursor,
.message-inline,
.inline-container,
.message-content.typing::after {
    display: none !important;
}

.message-content.user {
    background-color: #E8E5E0;
    color: #333333;
    font-size: 20px;
    font-family: PingFang-SC-Medium;
    font-weight: normal;
}

.message-content.system {
    background-color: #ffffff;
    color: #333333;
    font-size: 20px;
    font-family: PingFang-SC-Medium;
    font-weight: normal;
}

/* 修改思考文字的样式 */
.message-content.system :deep(.thinking),
.message-content.system :deep(.thinking-complete) {
    display: block;
    margin-top: 12px;
    margin-bottom: 12px;
    padding: 10px 14px;
    background-color: #f5f5f5;
    border-left: 3px solid #d4cfc8;
    border-radius: 4px;
    color: #6b5959;
    font-size: 16px;
    line-height: 2;
    letter-spacing: 1px;
    font-family: PingFang-SC-Regular;
    width: 100%;
    box-sizing: border-box;
    text-align: left;
}

.message-text {
    word-wrap: break-word;
    line-height: 1.5;
}

/* 移除重复和冲突的光标样式 */
.message-content.typing::after {
    content: none;
}

.input-area {
    position: sticky;
    bottom: 0;
    background-color: #f6f4f1;
    z-index: 10;
    padding: 0;
}

.ai-text-container {
    height: 70px;
    padding-left: 100px;
    padding-right: 100px;
    padding-bottom: 15px;
    padding-top: 10px;
    display: flex;
    position: relative;
    box-sizing: border-box;
}

.ai-text {
    position: relative;
    border-radius: 10px;
    border: none;
    outline: none;
    resize: none;
    height: 50px;
    width: 100%;
    padding-left: 24px;
    padding-right: 64px;
    padding-top: 15px;
    font-size: 20px;
    font-family: PingFang-SC-Medium;
    font-weight: normal;
}

.send-btn,
.stop-btn {
    height: 32px;
    width: 32px;
    position: absolute;
    right: 130px;
    top: 27px;
    cursor: pointer;
    z-index: 20;
}

.bottom-tip {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 15px;
    padding-top: 15px;
    background-color: #f6f4f1;
    z-index: 10;
}

.tip-p {
    color: #999999;
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    font-weight: normal;
}

form {
    display: flex;
}

input {
    flex: 1;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

button {
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

button:hover,
button:active {
    background-color: #0056b3;
}

/* 所有光标相关的样式都在这里定义 */
.cursor {
    display: inline-block;
    font-weight: bold;
    color: #333;
    animation: blink 0.7s infinite;
    margin-left: 2px;
}

@keyframes blink {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }
}

/* 清除所有其他可能影响光标的样式 */
.fixed-cursor,
.message-cursor,
.message-with-cursor,
.blinking-cursor,
.simple-cursor,
.message-inline,
.inline-container,
.message-content.typing::after {
    display: none !important;
    content: none !important;
}

/* 确保链接和文本内容最后没有空白 */
.message-content :deep(a),
.message-content :deep(span),
.message-content :deep(div) {
    margin: 0;
    padding: 0;
}
</style>
